export enum ApiUrlResourcesSpainEnum {}
